module.exports = __webpack_public_path__ + "static/img/pc_pd_v4_1.1374fc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/pc_pd_v4_1.png
// module id = 4xsl
// module chunks = 0